import React from 'react';

/**
 * DashboardLoadingBanner
 *
 * Props:
 * - isLoading: boolean indicating if any dashboard data is currently loading
 */
const DashboardLoadingBanner = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <div className="bg-blue-50 dark:bg-blue-900/30 border border-blue-200 dark:border-blue-800 rounded-lg p-4">
      <div className="flex items-center gap-2">
        <div className="w-4 h-4 border-2 border-blue-600 dark:border-blue-400 border-t-transparent rounded-full animate-spin" />
        <span className="text-blue-800 dark:text-blue-300 font-medium">
          Loading dashboard data...
        </span>
      </div>
    </div>
  );
};

export default DashboardLoadingBanner;


